export class AffCode {
  public constructor() {
    this.AffId = 0;
    this.AffCode = '';
    this.Descr = '';
    this.PublicDisplay = false;
    this.Icon = '';
    this.AffCodeTypeId = null;
    this.IconText = '';
    this.IconUrl = '';
    this.ListIsAvailableOnWebsite = false;
    this.IsAffinity = false;
    this.IsEntity = false;
    this.AffCodeType = '';
    this.Selected = false;
    this.ChildAffIds = [];
  }
  public AffId: number;
  public AffCode: string;
  public Descr: string;
  public PublicDisplay: boolean;
  public Icon: string;
  public AffCodeTypeId: number;
  public IconText: string;
  public IconUrl: string;
  public ListIsAvailableOnWebsite: boolean;
  public IsAffinity: boolean;
  public IsEntity: boolean;
  public AffCodeType: string;
  public Selected: boolean;
  public ChildAffIds: [];
}
